"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskCanceledError = void 0;
class TaskCanceledError extends Error {
    constructor(reason) {
        const message = `Task was canceled due to: "${reason}"`;
        super(message);
    }
}
exports.TaskCanceledError = TaskCanceledError;
//# sourceMappingURL=task-canceled-error.js.map